<template lang="html">
  <div class="content">
    <!-- <hr />

        <div class="image image-gathering"></div> -->

    <hr />

    <div class="f-c">
      <div class="f-1">
        <p class="question">
          Bent u op zoek?
        </p>
        <p>
          Wij nemen met regelmaat nieuwe Broeders in ons midden op.
        </p>
        <p>
          Neem contact op met de voorlichter van onze loge via het emailadres:
          <a href="mailto:logelaforce@gmail.com">logelaforce@gmail.com</a> om uw
          voor&shy;nemen kenbaar te maken.
        </p>
      </div>
      <div class="f-1">
        <p class="concern">
          Wij heten u graag welkom.
        </p>
        <p>
          Wij organiseren dikwijls een Avond voor Be&shy;lang&shy;stellenden.
          <br /><br />
          Op zo'n avond krijgt u een idee van hoe een avond bij de
          Vrijmetselaren eruit ziet en heeft u alle gelegen&shy;heid vragen te
          stellen. Houdt onze
          <router-link to="/werktafel">werk&shy;tafel</router-link> in de gaten
          of meld u direct aan.
        </p>
        <a
          class="button"
          href="mailto:logelaforce@gmail.com?subject=Aanmelding%20Avond%20voor%20Belangstellenden"
          >Meld u aan!</a
        >
      </div>
    </div>
    <hr />
    <div class="f-c">
      <div class="f-1">
        <p class="question">Adres:</p>
        <p class="">
          Vrijmetselaarsloge La Force no. 230<br />
          Amsterdamseweg 168-170<br />
          1182 HK Amstelveen<br />
        </p>
        <hr />
        <p class="question">Neem contact op</p>
        <p class="">
          Telefoon: 020 641 18 64<br />
          Email:
          <a href="mailto:logelaforce@gmail.com">logelaforce@gmail.com</a>
        </p>
      </div>
      <div class="f-1">
        <p class="concern">Informatie vd thesaurier:</p>
        <p>
          IBAN: NL66 INGB 0002 0696 85<br />
          t.n.v. 'Loge La Force'
        </p>
      </div>
    </div>
    <p class="quote">
      "Bidt, en u zal gegeven worden; zoekt, en gij zult vinden; klopt, en u zal
      opengedaan worden." <span class="author">~ Mattheus 7:7 </span>
    </p>
    <p class="concern">ANBI</p>
    <table>
      <tr>
        <td>Naam van de instelling</td>
        <td>
          'Loge La Force', 'La Force' of 'Loge La Force nr. 230 O∴ Amstelveen'
        </td>
      </tr>
      <tr>
        <td>RSIN</td>
        <td>816608180</td>
      </tr>
      <tr>
        <td>Telefoonnummer</td>
        <td>020-6411864</td>
      </tr>
      <tr>
        <td>Doelstelling</td>
        <td>Zoeken naar wat verbindt.</td>
      </tr>
      <tr>
        <td>Hoofdlijnen beleidsplan</td>
        <td>
          <ul>
            <li>Voortzetting Maconnieke vorming</li>
            <li>Samenwerking(en) zoeken met andere Loges en de Regio</li>
            <li>Vergroten naamsbekendheid van de Loge en de Orde</li>
            <li>Huidige leden behouden en nieuwe leden aantrekken</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Voorzitter</td>
        <td>R. Blok</td>
      </tr>
      <tr>
        <td>Secretaris</td>
        <td>CB</td>
      </tr>
      <tr>
        <td>Thesaurier</td>
        <td>D. Botje</td>
      </tr>
      <tr>
        <td>Beloningsbeleid</td>
        <td>Het bestuur krijgt geen bezoldiging.</td>
      </tr>
      <tr>
        <td>Actueel verslag</td>
        <td>
          <a href="/jaarverslag-2023-laforce.pdf" target="_blank">
            Jaarverslag 2023
          </a>
        </td>
      </tr>
      <tr>
        <td>Beleidsplan</td>
        <td>
          <a href="/beleidsplan-2024_2025.pdf" target="_blank">
            Beleidsplan 2024/2025
          </a>
        </td>
      </tr>
      <tr>
        <td>Financieel jaarverslag</td>
        <td>
          <a href="/financieel-jaarverslag-2023.pdf" target="_blank">
            Financieel jaarverslag 2023
          </a>
        </td>
      </tr>
    </table>

    <p class="concern">Overige</p>
    <table>
      <tr>
        <td>Privacyverklaring</td>
        <td>
          <a href="/privacy-verklaring.pdf" target="_blank">
            Privacy verklaring
          </a>
        </td>
      </tr>
    </table>

    <hr />
    <Proceedings></Proceedings>
  </div>
</template>

<script>
import Proceedings from "./Proceedings";

export default {
  components: {
    Proceedings,
  },
  methods: {},
  mounted() {
    //

    document.body.scrollTop = document.documentElement.scrollTop = 0;

    //
  },
};
</script>

<style lang="css" scoped>

.image-gathering {
    background: transparent url('/images/gathering.png') no-repeat center -450px;
    background-size: cover;
    height: 500px;
    margin-top: 30px;
}
</style>
